import React, { useEffect, useState } from "react";

import UsernameAdd from "../UserActions/UsernameAdd";

import actionIcon from "../../assets/img/icon/usernameIcon.png";

import './toDo.css';

const AddUsername = ({ userDetails }) => {
  const [isDone, setIsDone] = useState();

    useEffect(() => {
        if (userDetails?.username) {
            setIsDone(true);
        }
    }, [userDetails]);

  return (
    <>
      <section className="toDoList-card rounded-2">
        <div className="toDo-container">
          <div className="toDo-icon">
            <img src={actionIcon} alt="KYC Verification" className="img-fluid" />
          </div>
          <div className="toDo-text">
            <h4>Add Username/Tag</h4>
            <p>Kindly add a username to your account</p>
          </div>
          <button
              className={`toDo-button ${isDone ? "done-button" : ""}`}
              disabled={isDone}
              data-bs-toggle={!isDone ? "modal" : ""}
              data-bs-target={!isDone ? "#addUsernameModal" : ""}
          >
              {isDone ? "Done" : "Add Now"}
          </button>
        </div>
      </section>
    </>
  );
};

export default AddUsername;